var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"row page-title clearfix"},[_c('div',{staticClass:"page-title-left"},[_c('h5',{staticClass:"m-0"},[_vm._v(_vm._s(_vm.pageTitle))])])])}
var staticRenderFns = []

export { render, staticRenderFns }